// extracted by mini-css-extract-plugin
module.exports = {"list":"CustomerList_list__31Ga3"};